import "../index.css";
import { PencilIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { IServiceArea } from "@/types/common";
import { Card, Heading, IconButton, Row, Text, Tooltip } from "@/ui-kit";
import { AddressUtils } from "@/utils/address";

type IProps = {
  serviceAreas: IServiceArea[];
  onEdit?: () => void;
};

export const ServiceAreasCard = ({ serviceAreas, onEdit }: IProps) => {
  const { t } = useTranslation();

  return (
    <Card className="profile-card">
      <Card.Body>
        <Row gap="xl" alignmentVertical="top">
          <div className="profile-card__details">
            <Row gap="sm">
              <Heading level={3} tone="default">
                {t("label.service_areas")}
              </Heading>

              {onEdit && (
                <div className="profile-card__actions">
                  <Tooltip content={t("action.edit")} placement="bottom-end">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      color="neutral"
                      content={<PencilIcon />}
                      onClick={onEdit}
                      aria-label={t("action.edit")}
                    />
                  </Tooltip>
                </div>
              )}
            </Row>

            <div className="profile-card__section">
              {serviceAreas.map((serviceArea, i: number) => {
                const address = AddressUtils.format(serviceArea.address);
                return (
                  <Text size="lg" key={i} tone="default">
                    {address}
                  </Text>
                );
              })}
            </div>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};
